import DynamicImage from '@/components/DynamicImage';
import { useState } from 'react';
import QrcodeDialog from './QrcodeDialog';

const Qrcode = () => {
  return (
    <QrcodeDialog>
      <div className="rounded-cycle w-[106px] h-[106px] fixed z-50 flex bottom-[53px] right-[10px]">
        <DynamicImage
          src="https://osscdn.weiyouzhihui.com/editorVideo/1736481433577/Frame%201312321274%402x.png"
          width={106}
          height={106}
        ></DynamicImage>
      </div>
    </QrcodeDialog>
  );
};

export default Qrcode;
